var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 110,
    viewBox: "0 0 370 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_170)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_170)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.691 82.6332C364.586 82.6332 366.478 83.1696 367.832 84.512C369.187 85.8528 370 87.1952 370 89.0706C370 90.951 369.459 92.5616 368.105 93.6342C366.75 94.9767 364.855 95.5097 362.691 95.5097C360.527 95.5097 358.9 94.975 357.277 93.6342C355.923 92.2935 355.381 90.951 355.381 89.0706C355.381 87.1952 356.193 85.5863 357.546 84.512C359.172 83.1712 360.795 82.6332 362.691 82.6332Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.182 0H0V110H107.182V0Z",
    fill: "#E4002B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_170)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9874 69.4887L84.4481 37.0237C84.1759 30.0483 82.8215 25.2199 80.1146 22.5367C77.4076 19.8534 72.5365 18.5127 65.7699 18.5127V17.4384H102.041V18.5127C96.0858 18.5127 91.7523 19.8534 89.5881 22.5367C87.1533 25.2199 86.0695 30.0483 86.3384 37.0237L87.4222 92.8281H84.1742L31.3962 31.6572L30.0419 30.0483C29.7731 30.0483 29.5009 30.8528 29.5009 32.1952L28.4188 70.2915C28.1466 78.8791 29.5009 84.5137 31.9373 87.1952C34.6442 89.8784 39.5154 91.4874 47.0935 91.4874V92.5616H7.57812V91.4874C14.6152 91.4874 19.488 90.1449 22.195 87.7299C24.9019 85.3165 26.2562 80.2215 26.5251 72.973L27.8794 33.2678C27.8794 28.974 26.7956 25.488 24.3609 23.073C21.3817 20.1216 16.7828 18.5127 10.8278 18.5127V17.4384H37.3529L82.5527 69.7552C83.6331 71.0976 84.4481 71.6306 84.7169 71.6306C84.9874 71.9021 84.9874 71.0976 84.9874 69.4887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.294 79.6802V64.1239C127.213 65.4647 125.859 65.9993 123.695 66.5373C121.799 66.8071 119.633 67.0736 117.74 67.3418C115.303 67.8781 113.137 69.2205 111.785 71.0993C109.889 73.5143 109.078 76.7322 109.078 81.0227C109.078 85.588 109.348 88.5377 110.43 90.1466C111.514 91.7555 113.137 92.5633 115.302 92.5633C118.55 92.5633 121.799 91.2209 124.506 88.8058C126.941 86.3874 128.294 83.4377 128.294 79.6802ZM128.566 58.7575V52.0486C128.566 48.8275 128.025 46.6822 126.941 45.6096C125.859 44.5353 123.422 43.999 119.904 43.999C116.928 43.999 114.49 44.5353 112.326 45.6096C110.162 46.6822 108.537 48.023 107.994 49.9017H109.348C110.973 49.9017 112.326 50.4381 113.137 51.7788C114.221 52.8514 114.492 54.1922 114.492 55.8028C114.492 57.4134 113.68 59.0223 112.596 60.0966C111.242 61.1692 109.889 61.7055 107.994 61.7055C106.912 61.7055 105.828 61.4391 105.018 60.8994C102.582 59.2905 101.5 57.6816 101.5 55.2682C101.5 54.1939 101.77 52.8531 102.311 51.5107C103.666 48.561 106.641 46.1442 111.242 44.8035C114.492 43.7309 118.009 43.1945 121.527 43.1945C127.754 43.1945 132.353 44.2672 135.601 46.4141C138.58 48.2912 139.933 50.7062 139.933 53.6576L140.204 79.4137C140.204 83.9757 140.474 86.9287 140.746 87.9997C141.287 90.6829 142.91 92.0237 145.617 92.0237C148.054 92.0237 149.408 90.951 150.22 88.8041C151.031 86.6572 151.302 83.7042 151.031 79.6802C151.031 78.6076 151.031 77.5367 150.761 76.4624C150.761 75.3881 150.761 74.3138 150.489 73.2412V72.1702H151.841L152.113 77.2668C152.113 78.8774 152.382 80.4864 152.382 81.8288C152.653 86.3874 152.113 89.3405 150.759 90.951C149.134 92.8265 145.886 93.9007 141.013 93.9007C137.226 93.9007 134.247 93.3644 132.352 92.2918C130.186 90.9494 128.564 88.5343 128.021 85.3148C126.126 89.069 123.419 91.4857 119.632 92.8265C117.464 93.6326 114.488 93.9007 110.698 93.9007C106.91 93.9007 103.661 93.0946 100.955 91.4857C97.1645 89.3388 95.5414 86.1193 95.5414 81.8288C95.8119 77.5367 97.7073 74.0473 101.496 71.0976C105.284 68.4144 109.617 66.8055 114.757 66.2658C119.902 65.9977 123.419 65.1932 125.314 64.3904C127.754 63.5826 128.566 61.7072 128.566 58.7575Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.47 67.6083V72.973C189.47 74.8551 189.47 76.464 189.74 78.073C189.74 83.4394 189.197 87.1969 187.845 89.3421C185.953 92.0253 182.162 93.6359 176.479 93.6359C171.065 93.6359 167.275 92.5616 164.838 90.1466C162.403 88.0014 161.051 84.7802 161.32 80.4897L161.592 47.49H151.305V46.4174C158.344 44.8068 163.486 41.051 167.275 35.4164C169.982 30.8561 171.605 25.4914 171.605 19.5886H173.5V44.2722H188.386V47.7598H173.5V79.4137C173.5 83.7059 173.772 86.3891 174.041 87.4634C174.853 90.4131 177.017 91.7555 179.996 91.7555C183.515 91.7555 185.951 90.1466 187.033 86.6589C187.845 84.2455 188.117 79.9517 188.117 73.5143V67.8781L189.47 67.6083Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.548 16.6339C215.442 16.6339 217.337 17.1702 218.692 18.5127C220.046 19.8534 220.587 21.1959 220.587 23.073C220.587 24.95 220.046 26.5606 218.692 27.6332C217.337 28.974 215.716 29.512 213.548 29.512C211.656 29.512 209.761 28.974 208.406 27.6332C207.052 26.2908 206.511 24.95 206.511 23.073C206.511 21.1959 207.323 19.5853 208.675 18.5127C210.031 17.1702 211.656 16.6339 213.548 16.6339ZM220.315 42.9264L220.587 86.9271C220.587 88.536 220.856 89.6103 221.128 89.8768C221.398 90.1432 221.667 90.4114 222.21 90.6812C224.105 91.2175 227.896 91.4857 233.849 91.4857V92.56H194.603V91.4857C197.31 91.4857 199.477 91.4857 201.642 91.2175C203.808 90.9494 205.429 90.6812 207.056 90.4114C207.598 90.1432 207.867 88.8025 207.867 86.9271L208.138 50.7062C208.138 49.0973 207.867 48.2911 207.598 48.023C207.056 47.2185 206.514 46.6822 205.972 46.6822C204.349 46.4141 200.83 46.1442 195.418 46.1442V45.0716L220.315 42.9264Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.022 68.1479C272.022 59.5603 270.938 53.3911 269.317 49.9034C267.422 45.8794 263.903 43.7325 259.032 43.7325C254.431 43.7325 251.182 45.6113 249.286 49.6352C247.391 53.6592 246.31 59.5603 246.037 68.1479C245.768 76.7305 246.578 82.9047 248.473 86.9287C250.098 90.6829 253.618 92.8281 259.03 92.8281C263.901 92.8281 267.151 90.9527 269.315 86.9287C271.211 82.6332 272.293 76.464 272.022 68.1479ZM285.555 68.1479C285.824 75.6562 283.119 81.8304 277.162 86.9287C271.748 91.4873 265.797 93.6359 259.03 93.6359C251.992 93.6359 246.037 91.4873 241.165 87.4634C235.209 82.6349 232.504 76.1975 232.776 68.1479C233.045 60.6329 236.024 54.4637 241.977 49.6352C247.122 45.3414 253.075 42.928 259.301 42.928C265.798 42.928 271.481 45.0733 276.352 49.0989C282.307 53.9274 285.283 60.3664 285.555 68.1479Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.837 63.8524L308.567 86.6572C308.567 88.2678 308.567 89.3404 308.837 89.6102C309.11 89.8784 309.379 90.1449 310.19 90.4114C310.733 90.6812 312.085 90.951 313.709 90.951C315.335 91.2192 316.958 91.2192 318.311 91.2192V92.2935H284.208V91.2192C286.103 91.2192 287.995 91.2192 289.891 90.951C291.786 90.6812 293.409 90.4114 295.036 90.1449C295.577 89.8784 295.845 88.536 295.845 86.6572L296.931 51.2442V49.0973C296.931 49.0973 296.659 47.7548 296.39 47.4867L295.578 46.414C294.765 45.8777 291.519 45.6096 286.105 45.6096V44.537L308.839 42.6582L308.569 57.415C309.111 54.1939 310.192 51.2442 312.087 48.5609C314.525 45.0716 316.958 43.1945 319.667 42.9264C322.372 42.6566 323.999 42.3884 324.81 42.3884C330.224 42.3884 334.284 43.999 337.532 46.6822C340.239 49.0973 341.591 52.0486 341.591 55.5346L342.403 86.3857C342.403 87.998 342.672 89.0689 342.944 89.3388C343.213 89.6086 343.483 89.8767 344.298 90.1432C345.108 90.4114 346.19 90.6812 348.086 90.6812C349.981 90.951 351.876 90.951 353.5 90.951V92.0236H319.396V90.951C320.751 90.951 322.372 90.951 324.268 90.6812C326.163 90.4114 327.786 90.1432 329.139 89.8767C329.68 89.6086 329.949 88.2678 329.949 86.3857L329.68 56.8754C329.68 53.1196 329.411 50.1682 328.596 48.2911C327.514 45.0716 325.35 43.461 322.371 43.461C318.583 43.461 315.333 45.6096 312.897 50.1682C311.002 53.9274 309.647 58.4877 308.837 63.8524Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.303 29.7801C115.303 29.2438 115.575 26.0226 115.575 20.1216V17.4384H115.033C112.596 17.4384 111.785 19.3155 110.973 23.3394H110.701L110.973 17.1685H116.928H122.88L123.152 23.3394H122.88C122.068 19.3155 121.257 17.4384 118.82 17.4384H118.281V20.6579V25.2198C118.281 28.1712 118.281 30.0483 118.55 30.3181C118.55 30.5863 119.904 30.5863 121.799 30.8544V31.1226H116.928H112.055V30.8544C114.221 30.3165 115.033 30.3164 115.303 29.7801Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.249 30.8528H130.187H125.857V30.5846C127.48 30.5846 128.564 30.5846 128.564 30.0483C128.564 29.7802 128.835 28.4394 128.835 25.7562V22.8048C128.835 19.8534 129.107 18.2428 128.835 17.9747C128.835 17.7082 127.753 17.7082 126.128 17.4384V17.1702H130.187H133.706V17.4384C132.353 17.4384 131.542 17.7082 131.271 17.9747C131.271 18.2428 130.999 20.1216 130.999 23.6093H137.497C137.497 20.3914 137.497 18.5127 137.226 17.9747C137.226 17.7082 136.413 17.7082 134.79 17.4384V17.1702H138.308H142.369V17.4384C140.746 17.4384 139.935 17.4384 139.662 17.9747V23.8774C139.662 27.6333 139.662 29.7802 139.935 30.0483C140.205 30.3165 141.017 30.3165 142.642 30.5846V30.8528H138.31H134.522V30.5846C136.146 30.5846 136.957 30.3165 136.957 30.0483C137.229 29.7802 137.229 27.9014 136.957 24.1472H130.463V30.0483C130.463 30.3165 131.274 30.3165 132.898 30.5846L134.249 30.8528Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2_170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 370,
    height: 110
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0H0V110H370V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.324 30.0483C148.324 29.7802 148.595 28.4394 148.595 25.7562V22.8048V17.9747C148.595 17.7082 147.513 17.7082 145.888 17.4384V17.1702H152.384H158.882L159.152 22.5366H158.882C158.341 18.2428 157.257 17.4384 153.738 17.4384C152.384 17.4384 151.843 17.4384 151.843 17.7082C151.843 17.9747 151.843 19.8534 151.572 23.3411H152.384C154.822 23.3411 155.36 22.5366 155.634 19.5853H155.904V27.6349H155.634C155.361 24.6835 154.822 23.6093 152.927 23.6093H151.843V30.0483C151.843 30.3165 152.654 30.3165 154.55 30.3165C158.341 30.3165 159.421 29.512 159.964 24.95V28.7059V30.8528H151.843H145.349V30.5846C147.241 30.3165 148.054 30.3165 148.324 30.0483Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e483c140093a530ac7e9c5f5b303e5b.svg";
export { ForwardRef as ReactComponent };